export default "__VITE_ASSET__XJOEGXHA__"